import { MoreVertical, Edit } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { BirdieGameGroup } from "@/types";
import { useNavigate } from "react-router-dom";

interface GameActionsProps {
  game: BirdieGameGroup;
  onSuccess: () => void;
}

const GameActions = ({ game }: GameActionsProps) => {
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="p-2 rounded-full hover:bg-gray-100">
        <MoreVertical className="h-5 w-5 text-gray-600" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => navigate(`/games/${game.id}/edit`)} className="cursor-pointer">
          <Edit className="mr-2 h-4 w-4" />
          <span>Edit Game</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default GameActions;
